import $ from 'jquery';
import slick from 'slick-carousel';

export default() => {
	(function (Collection, $) {

		var $dom = {};
		var arrow = '<svg fill="#959595" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
		var cacheDom = function cacheDom() {
			$dom.collectionDropDown = $('.js-col-mobile-dropdown');
		};

		var openDropDown = function openDropDown() {
			var IconSliderSliderOptions = {
				slidesToShow: 11,
				slidesToScroll: 4,
				dots: false,
				arrows: true,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
				responsive: [{
					breakpoint: 992,
					settings: {
						slidesToShow: 9
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 4
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 4
					}
				}]
			};
			$dom.collectionDropDown.slick(IconSliderSliderOptions);
		};

		Collection.init = function () {
			cacheDom();
			openDropDown();
		};
	})(window.Collection = window.Collection || {}, $, undefined);
};